import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAsObservableSource } from 'mobx-react-lite';
import { FormHeaderWrapper, Header } from 'src/domains/layouts/shared/cms/form/formHeader/FormHeader.style';
import { ContentH3, ParagraphDefault } from 'src/domains/layouts/shared/typography/Content.style';
import { Button } from 'src/domains/layouts/shared/buttons/Button';

interface FormHeaderPropsTypes {
    defaultLabel: string,
    isEditMode: boolean,
    editModeLabel?: string,
    children?: string,
    resetForm?: () => void,
}

export const FormHeader = observer('FormHeader', (propsIn: FormHeaderPropsTypes) => {
    const props = useAsObservableSource(propsIn);
    const { isEditMode, defaultLabel, editModeLabel, children, resetForm } = props;

    return (
        <FormHeaderWrapper>
            <Header>
                <ContentH3>
                    {isEditMode ? editModeLabel : defaultLabel}
                </ContentH3>

                {isEditMode && (
                    <Button onClick={resetForm}>
                    Back
                    </Button>
                )}
            </Header>

            {children === undefined ? null : <ParagraphDefault>{children}</ParagraphDefault>}
        </FormHeaderWrapper>
    );
});
